import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "line-icon",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M-187 89h24v24h-24zM10 20H5c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1h14c.6 0 1 .4 1 1v5M4 8h16M8 4v4" }, null, -1),
    _createElementVNode("path", { d: "m17 12 4 2v5l-4 2-4-2v-5zM17 16l-4-2M17 16v5M17 16l4-2" }, null, -1)
  ])))
}
export default { render: render }